import { collect } from 'collect.js';
import { Globals } from "../../../globals";
import { Permission } from "../../../core/enum/permission";
import { AppInjector } from "../../../../app-injector";
import { DocuploadType } from "../../../core/enum/docupload-type";
import { MatSnackBar } from '@angular/material/snack-bar';
import { setDefaultLanguage } from '../../../akita/multilingual/multilingual.model';

declare let $: any;

export class GenericComponent {

  Permission = Permission;
  DocuploadType = DocuploadType;
  public snackbar: MatSnackBar = AppInjector ? AppInjector.get(MatSnackBar) : null;
  public globals: Globals = AppInjector ? AppInjector.get(Globals) : null;

  // eslint-disable-next-line no-empty-function
  constructor(public oldGlobals?: Globals) { }

  public removeOverlay(): void {
    const dismissButtons = $('button[data-dismiss="modal"]');
    for (let i = 0; i < dismissButtons.length; i++) {
      $(dismissButtons[i]).click();
    }

    const overlays = $('.modal-backdrop');
    for (let i = 0; i < overlays.length; i++) {
      $(overlays[i]).click();
    }
  }

  public hasRight(acl) {
    return this.globals.project[acl];
  }

  public hasPermission(permission: Permission): boolean {
    const permissions = this.globals?.permissions || [];
    if (!permission) return false;
    return permissions.includes(permission.toString());
  }

  public hasModule(moduleId): boolean {
    if (this.globals.modules) {
      if (this.globals.project && this.globals.project.customers && this.globals.project.customers.license_type === 'enterprise' && (moduleId === 'stakeholders' || moduleId === 'contactpersons' || moduleId === 'requirements' || moduleId === 'requirements_by' || moduleId === 'analysis' || moduleId === 'issues' || moduleId === 'tasks' || moduleId === 'contactmoments' || moduleId === 'layers' || moduleId === 'documents')) {
        return true; // set it to stakeholder-management
      }
      if (moduleId === 'contexts') {
        return true
      }
      if (moduleId === 'ai_analysis') {
        return this.globals.modules.some(module => moduleId === module.module_id);
      }
      // to avoid permit/permits conflict
      if (moduleId === 'permit' || moduleId === 'permits') {
        return this.globals.modules.some(module => module.module_id === 'permit' || module.module_id === 'permits');
      }
      if (moduleId === 'share_only') {
        return this.globals.modules.some(module => module.module_id === 'share');
      }
      if (moduleId === 'external_share') {
        return this.globals.modules.some(module => module.module_id === 'external_share');
      }
      if (moduleId.includes('share')) {
        return this.globals.modules.some(module => module.module_id === 'share' || module.module_id === 'external_share');
      }
      return this.globals.modules.some(module => moduleId.includes(module.module_id));
    }
    return false;
  }

  /**
   * Filter shared projects: internal by has_shared, external by has_external_shared and share module.
   * Use when building globals.shared_projects or options for share UI (generic-share-items, batch-snackbar, chat-channel-sidebar).
   */
  public filterSharedProjectsByTypeAndModule(projects: any[]): any[] {
    if (!Array.isArray(projects)) return [];
    const hasShareModule = this.hasModule('share');
    return projects.filter((proj: any) => {
      if (proj.is_external_project === true) {
        return proj.has_external_shared === true && hasShareModule;
      }
      return proj.has_shared === true;
    });
  }

  public hasSLA(): boolean {
    if (this.globals.project && this.globals.project.sla_enabled) {
      return true;
    }
    return false;
  }

  public hasKPI(): boolean {
    if (this.globals.project.complaints_kpi) {
      return true;
    }
    return false;
  }
  // role check
  public hasRole(role): boolean {
    let value = false;
    if (this.globals.user.scope) {
      this.globals.user.scope.data.forEach(el => {
        if (!el.is_subproject) {
          value = collect(el.roles).contains((value, key) => value.name == role);
        }
      });
    }
    return value;
  }
  //standing level
  public hasStandingLevel(router): boolean {
    if (!router.url.includes('sub')) {
      return true;
    }
    return false;
  }
  //personalization check
  public hasPersonalization(): boolean {
    if (this.globals.project_personalization || this.globals.customer_personalization) {
      return true;
    }
    return false;
  }
  //get language code
  public haslanguageCode(): string {
    return setDefaultLanguage(this.globals, 'user');
  }


  public integrationEnabled(integration: string): boolean {
    switch (integration) {
      case 'arcgis':
        return this.globals.projectConfigs['services.integration.arcgis.enabled'];
        break;
      case 'relatics':
        return this.globals.projectConfigs['services.relatics.enabled'];
        break;
      case 'sharepoint':
        return this.globals.projectConfigs['services.sharepoint.enabled'];
        break;
    }

    return false;
  }

  public trackByFn(index, item): any {
    if (!item) {
      return null;
    }

    if (!item.id && !item.email) {
      return JSON.stringify(item);
    }

    return item.id || item.email;
  }

  public idComparator(o1: any, o2: any): boolean {
    return o1.id === o2.id;
  }
  //personilization project logic set
  public projectPersonalizationSetup(type): any {
    switch (type) {
      case 'color':
        if (this.globals.project_personalization) {
          if (this.globals.project_personalization.metadata) {
            if (this.globals.project_personalization.metadata.report) {
              return `#${this.globals.project_personalization.metadata.report.color}`;
            }
          }
        }
        return this.companyPersonalizationSetup(type);
      case 'logo':
        if (this.globals.project_personalization) {
          if (this.globals.project_personalization.logo) {
            return this.globals.project_personalization.logo;
          }
        }
        return this.companyPersonalizationSetup(type);
      default:
        return '';
    }
  }
  //personilization company logic set
  public companyPersonalizationSetup(type): any {
    switch (type) {
      case 'color':
        if (this.globals.customer_personalization) {
          if (this.globals.customer_personalization.metadata) {
            if (this.globals.customer_personalization.metadata.report) {
              return `#${this.globals.customer_personalization.metadata.report.color}`;
            }
          }
        }
        return '#2800D2';
      case 'logo':
        if (this.globals.project_personalization) {
          if (this.globals.project_personalization.logo) {
            return this.globals.project_personalization.logo;
          }
        }
        return '';
      default:
        return '';
    }
  }
}
